import { render, staticRenderFns } from "./MessageBoxButton.vue?vue&type=template&id=1cd2e72c&scoped=true"
import script from "./MessageBoxButton.vue?vue&type=script&lang=js"
export * from "./MessageBoxButton.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxButton.vue?vue&type=style&index=0&id=1cd2e72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd2e72c",
  null
  
)

export default component.exports